import { render, staticRenderFns } from "./StoreStats.vue?vue&type=template&id=fb18c700&scoped=true"
import script from "./StoreStats.vue?vue&type=script&lang=js"
export * from "./StoreStats.vue?vue&type=script&lang=js"
import style0 from "./StoreStats.vue?vue&type=style&index=0&id=fb18c700&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb18c700",
  null
  
)

export default component.exports